import {getUrlParam, setOrDeleteStringParam} from '@hconnect/common/utils'
import {useSearchParams} from 'react-router'

import {DowntimeStatisticsViewToggleOption, DowntimeStatisticsViewToggleOptions} from '../consts'

const DowntimeStatisticsYtmMtmPageParams = {
  KPI_VIEW: 'kpiView'
}

export const useDowntimeStatisticsYtmMtmState = (
  defaultValue: DowntimeStatisticsViewToggleOption = DowntimeStatisticsViewToggleOptions.YTM_VIEW
) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const kpiViewParam = getUrlParam(searchParams, DowntimeStatisticsYtmMtmPageParams.KPI_VIEW)
  const kpiView = isKpiViewOption(kpiViewParam) ? kpiViewParam : defaultValue

  const setkpiView = (value: DowntimeStatisticsViewToggleOption) => {
    const newParams = new URLSearchParams(searchParams)

    setOrDeleteStringParam(newParams, DowntimeStatisticsYtmMtmPageParams.KPI_VIEW, value)
    setSearchParams(newParams, {replace: true})
  }

  return {kpiView, setkpiView}
}

const isKpiViewOption = (value: string | undefined): value is DowntimeStatisticsViewToggleOption =>
  Object.values(DowntimeStatisticsViewToggleOptions).includes(
    value as DowntimeStatisticsViewToggleOption
  )
